// extracted by mini-css-extract-plugin
export default {"alert":"SizeAlert_alert__Bqwge","alertContent":"SizeAlert_alertContent__wVYAk","alertClose":"SizeAlert_alertClose__kgCvT"};